import React from 'react';
import { useSelector } from 'react-redux';

import { FjCheckbox } from 'components/primitives';
import { selectUserIsTabbing } from 'selectors/ui';

type CheckboxProps = Omit<React.ComponentProps<typeof FjCheckbox>, 'outlineOnFocus'>;

const Checkbox = (otherProps: CheckboxProps): React.JSX.Element => {
  const isTabbing = useSelector(selectUserIsTabbing);
  return <FjCheckbox outlineOnFocus={isTabbing} {...otherProps} />;
};

export default Checkbox;
